import { render, staticRenderFns } from "./EnterpriseEmail.vue?vue&type=template&id=bdcf8f5e&scoped=true&slot-scope=scope&"
import script from "./EnterpriseEmail.vue?vue&type=script&lang=js&"
export * from "./EnterpriseEmail.vue?vue&type=script&lang=js&"
import style0 from "./EnterpriseEmail.vue?vue&type=style&index=0&id=bdcf8f5e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcf8f5e",
  null
  
)

export default component.exports